import { useEffect, useState } from "react";
import { api } from "../api/client.js";

interface MetricImport { id: string; source: string; file_hash: string; status: string; row_count: number; created_at: string; }

export function ResultsPage() {
  const [imports, setImports] = useState<MetricImport[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<{ imports: MetricImport[] }>("/metric-imports?limit=20")
      .then(r => setImports(r.imports ?? []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const statusColor = (s: string) => s === "committed" ? "#2d6a4f" : s === "previewed" ? "#d97706" : "#dc2626";

  if (loading) return <div style={{ padding: 24, color: "#888" }}>Cargando…</div>;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Resultados y métricas</h1>
        <p style={{ color: "#666", fontSize: 13, margin: "4px 0 0" }}>Importaciones CSV y métricas de publicaciones</p>
      </div>

      <div style={{ background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8, padding: "10px 16px", marginBottom: 20, fontSize: 13, color: "#0369a1" }}>
        Las métricas de TikTok requieren credenciales de API (actualmente BLOCKED_EXTERNAL). Importa datos manualmente vía CSV.
      </div>

      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Importaciones de métricas</h2>
        {imports.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 10, padding: 32, textAlign: "center", color: "#888" }}>
            Sin importaciones. Importa métricas desde CSV para ver resultados de publicaciones.
          </div>
        ) : (
          <div style={{ background: "#fff", borderRadius: 10, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "2px solid #f0ece4" }}>
                  {["Fuente", "Filas", "Estado", "Fecha"].map(h => (
                    <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontSize: 12, color: "#888", fontWeight: 600 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {imports.map(im => (
                  <tr key={im.id} style={{ borderBottom: "1px solid #f8f6f0" }}>
                    <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 500 }}>{im.source}</td>
                    <td style={{ padding: "12px 16px", fontSize: 13, color: "#666" }}>{im.row_count}</td>
                    <td style={{ padding: "12px 16px" }}>
                      <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 12, background: statusColor(im.status) + "22", color: statusColor(im.status), fontWeight: 600 }}>{im.status}</span>
                    </td>
                    <td style={{ padding: "12px 16px", fontSize: 12, color: "#aaa" }}>{new Date(im.created_at).toLocaleDateString("es")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div style={{ background: "#fff", borderRadius: 10, padding: 24 }}>
        <h3 style={{ margin: "0 0 8px", fontSize: 15, fontWeight: 600 }}>Indicadores disponibles</h3>
        <p style={{ fontSize: 13, color: "#666", margin: "0 0 12px" }}>Los indicadores se calculan cuando existen métricas importadas con ventanas de al menos 28 días.</p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 10 }}>
          {["Guardados / 1000 vistas", "Compartidos / 1000 vistas", "Tasa de compleción", "Ratio medio de visionado", "Crecimiento de seguidores", "Comentarios cualificados"].map(ind => (
            <div key={ind} style={{ background: "#f8f6f0", borderRadius: 8, padding: "10px 12px", fontSize: 12, color: "#666" }}>{ind}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
